'use client';

import { ReactNode } from 'react';
import { useTenantAndVariant } from '../../../../multitenancy/TenantAndVariantContext';
import { HeaderShowcase } from '../header-showcase/client-header';
import { HeaderClassic } from '../header-classic/client-header';
import { HeaderDopesnow } from '../header-dopesnow/client-header';
import { HttpTypes } from "@medusajs/types";

interface DynamicHeaderProps {
  regions: HttpTypes.StoreRegion[];
  collections: HttpTypes.StoreCollection[];
  categories: HttpTypes.StoreProductCategory[];
  cartButton: ReactNode;
}

export function DynamicHeader({ regions, collections, categories, cartButton }: DynamicHeaderProps) {
  const { headerVariant } = useTenantAndVariant();

  switch (headerVariant) {
    case 'dopesnow':
      return <HeaderDopesnow regions={regions} collections={collections} categories={categories} cartButton={cartButton} />;
    case 'showcase':
      return <HeaderShowcase regions={regions} collections={collections} categories={categories} cartButton={cartButton} />;
    case 'classic':
    default:
      return <HeaderClassic regions={regions} collections={collections} categories={categories} cartButton={cartButton} />;
  }
}
